const GEOLINQ_LOCALE = 'GeolinQ-Locale';

const storeLocale = (locale) => {
    if( sessionStorage ) {
        sessionStorage.setItem(GEOLINQ_LOCALE, locale);
    }
}

const readLocale = () => {
    let locale = undefined;
    if( sessionStorage ) {
        locale = sessionStorage.getItem(GEOLINQ_LOCALE);
    } 
    
    return locale;
}

const resolveLocale = (requestedLocale, locales) => {
	const requestedLocales = [...window.navigator.languages];
	
    const stored = readLocale();

	// the order of resolve:
	// stored locale in session
	// requested locale by bootstrap 

	// requested locale by init function
	if( requestedLocale ) {
		requestedLocales.unshift(requestedLocale);
	}

	// first - try stored in session storage
    if( stored ) {
		requestedLocales.unshift(stored);
	}
	
	// last, try browserlanguages
    
    // try to pick
    return pickLocale(requestedLocales, locales);
}

const pickLocale = (requestedLocales, availableLocales) => {
	for(let i = 0; i < requestedLocales.length; i++) {
		const locale = requestedLocales[i];
		
		if( availableLocales.has(locale) ) {
			return locale;
		}
	
		const index = locale.indexOf('-');
		if( index >= 0 ) {
			const localePart = locale.substring(0, index);
			
			if( availableLocales.has(localePart) ) {
				return locale;
			}
		}		
	}	
	
	return "unknown locale";
}


const getBrowserLanguages = () => {
	return [...window.navigator.languages].map( locale => {
		const index = locale.indexOf('-');
		
		if( index >= 0 ) {
			return locale.substring(0, index);
		} else {
			return locale;
		}		 
	});
}


const getLocale = (requestedLocale, locales, defaultLocale) => {
	let locale = requestedLocale;
		
	if( (locales || []).indexOf( requestedLocale ) < 0 ) {
		locale = defaultLocale;
	}
	
	return locale;
}

export {
	getLocale, storeLocale, resolveLocale
}
